"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("@formily/vue");
var composition_api_1 = require("@vue/composition-api");
// @ts-ignore
var Images_vue_1 = __importDefault(require("./Images.vue"));
var Images = (0, composition_api_1.defineComponent)({
    name: 'Images',
    props: ['value', 'imageWidth'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs;
        return function () {
            var props = __assign(__assign(__assign({}, attrs), curProps), { style: 'white-space: pre' });
            return (0, vue_1.h)(Images_vue_1.default, {
                attrs: props,
            }, {});
        };
    },
});
exports.default = Images;
